//LIBRARY
import styled, { createGlobalStyle } from "styled-components";

//MISC
import { BORDER_RADIUS, COLORS } from "constants/variables";

export const LandscapeOverlay = styled.div`
  display: ${({ isVisible }) => (isVisible ? "none" : "relative")};
`;

export const LandscapeMessage = styled.div`
  display: ${({ isVisible }) => (isVisible ? "relative" : "none")};
  justify-content: center;
  align-items: center;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 9999;
  flex-direction: column;
  text-align: center;
`;

export const GlobalStyle = createGlobalStyle`

  ::-webkit-scrollbar {
    width: 4px;
  }

  ::-webkit-scrollbar-track {
    background: ${COLORS.Background};
    border-radius: ${BORDER_RADIUS.radius8};
  }

  ::-webkit-scrollbar-thumb {
    background: ${COLORS.Yellow};
    border-radius: ${BORDER_RADIUS.radius8};
  }
`;
